import React, { useContext, useReducer, useEffect } from 'react';
import { Box, Tooltip } from '@mui/material'
import MegaAutoComplete from '../../Utils/megautocomplete';
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import { lockedReducer } from '../../Utils/reducers';
import { externalComponent } from '../../AppRoutes';
import validateData from './validateData';
import { api } from '../../../services/api';
import toast from 'react-hot-toast';

const url = 'clientes_desconsiderados'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (setLoader, data, getData, handleClose) => {

    setLoader(true)
    let res = ''
    if (data.id !== 0 && data.id !== undefined) {
        res = await api.put(url, data)
    } else {
        res = await api.post(url, data)
    }

    if (res.status === 200 || res.status === 201) {
        toast.success(`Cliente ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Cliente não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: ${res.data}`)
    setLoader(false)
}

const EditClientesDesconsiderados = ({ data, handleClose, reloadData }) => {

    const [state, setState] = useReducer(lockedReducer, {
        editRow: null,
        cliente: [],
        empresa: [],
        ...data,
        id: data.id ? data.id : 0
    })

    const { setLoader } = useContext(externalComponent)
    const validTable = validateData(state)

    useEffect(() => {

        if (data.id !== 0 && data.id !== undefined) {
            const cliente = { id: data.id_cliente, label: data.nome_cliente }
            const empresa = { id: data.id_empresa, label: data.nome_empresa }
            setState({ cliente: cliente, empresa: empresa })
        }

    }, [])

    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: "sm" }}
                handleClose={handleClose}
                open={true}
                title={`${getTitle(state)} Cliente desconsiderados`}
                content={

                    <Box className='item-content-modal noborder'>

                        <Box className='item-profile-row'>
                            <MegaAutoComplete
                                id="desconsideradosClientes"
                                multiple={false}
                                value={state.cliente}
                                onChange={(data) => { setState({ cliente: data }) }}
                                noOptionsText={'Digite para procurar um cliente'}
                                timeoutUrl='/frete/clientes_empresas/'
                                timeoutParam='label'
                                label='Clientes'
                            />
                        </Box>

                        <Box className='item-profile-row'>
                            <MegaAutoComplete

                                id="desconsideradosEmpresa"
                                multiple={false}
                                value={state.empresa}
                                onChange={(data) => { setState({ empresa: data }) }}
                                noOptionsText={'Digite para procurar uma empresa'}
                                timeoutUrl='/frete/filiais'
                                timeoutParam='label'
                                label='Empresa'
                            />
                        </Box>

                    </Box>

                }

                action={
                    <Tooltip title={validTable} placement="left">
                        <span>
                            <ColorButton disabled={validTable} onClick={() => submit(setLoader, state, reloadData, handleClose)}>Salvar</ColorButton>
                        </span>
                    </Tooltip>
                }
            />

        </>
    )
}

export default EditClientesDesconsiderados;